import styled from 'styled-components';

export const SuccessHeader = styled.h1`
  ${(props) => props.theme.newTypography.textStyleHeading};
  color: ${(props) => props.theme.newPalette.neutral.N800};
`;

export const SuccessText = styled.p`
  ${(props) => props.theme.newTypography.textStyleBodySmall};
  margin: 0;
  text-align: center;
`;

export const InfoText = styled(SuccessText)`
  padding-top: 1.5px;
`;

export const SuccessContainer = styled.div`
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  gap: 20px;
  @media screen and (min-width: 0px) and (max-width: 480px) {
    height: 60%;
  }
`;

export const SuccessInfoContainer = styled.a`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  cursor: pointer;
`;

export const SuccessInfoText = styled.p`
  ${(props) => props.theme.newTypography.textStyleBody};
  color: ${(props) => props.theme.newPalette.neutral.N800};
  margin: 0;
`;

export const VaultIDText = styled.p`
  ${(props) => props.theme.newTypography.textStyleBody};
  color: ${(props) => props.theme.newPalette.neutral.N800};
  margin: 0;
`;

export const VaultIdContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  border-radius: 3px;
  background-color: ${(props) => props.theme.newPalette.neutral.N200};
  width: 90%;
`;

export const ButtonContainer = styled.div`
  margin: 10px 0;
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  gap: 10px;
`;

export const SubmitSuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  min-height: 100%;
  width: 100%;
`;

export const MobileHeaderContainer = styled.div`
  display: none;
  @media screen and (min-width: 0px) and (max-width: 480px) {
    display: flex;
    width: 100%;
  }
`;

export const FileUploadErrorText = styled.p`
  ${(props) => props.theme.newTypography.textStyleBodySmall};
  color: ${(props) => props.theme.newPalette.red.R300};
  margin: 0;
  margin-bottom: 20px;
  text-align: center;
`;
